import * as AccordionPrimitive from '@radix-ui/react-accordion'
import type { ReactNode } from 'react'
import { ChevronIcon } from '../../icons/ChevronIcon'

type AccordionPanelItemProps = {
  value: string
  title: string
  children: ReactNode
}

type AccordionPanelSingleProps = {
  type: 'single'
  defaultValue?: string
  value?: string
  onValueChange?: (value: string) => void
  collapsible?: boolean
}

type AccordionPanelMultipleProps = {
  type: 'multiple'
  defaultValue?: string[]
  value?: string[]
  onValueChange?: (value: string[]) => void
}

type AccordionPanelProps = (AccordionPanelSingleProps | AccordionPanelMultipleProps) & {
  children: ReactNode
  className?: string
}

export const AccordionPanel = ({ children, className = '', ...props }: AccordionPanelProps) => {
  return (
    <AccordionPrimitive.Root
      {...props}
      className={`ap:w-full ap:rounded-md ap:bg-surface-background ap:shadow-soft ${className}`.trim()}
    >
      {children}
    </AccordionPrimitive.Root>
  )
}

export const AccordionPanelItem = ({ value, title, children }: AccordionPanelItemProps) => {
  return (
    <AccordionPrimitive.Item
      value={value}
      className="ap:overflow-hidden ap:border-t ap:border-stroke-primary ap:first:rounded-t-md ap:first:border-t-0 ap:last:rounded-b-md"
    >
      <AccordionPrimitive.Header className="ap:m-0 ap:flex">
        <AccordionPrimitive.Trigger className="ap:group ap:flex ap:flex-1 ap:cursor-pointer ap:items-center ap:justify-between ap:gap-md ap:px-2xl ap:py-xl ap:text-left ap:text-content-primary ap:outline-none ap:data-[state=closed]:hover:bg-surface-primary">
          {title}
          <ChevronIcon className="ap:shrink-0 ap:text-content-secondary ap:transition-transform ap:duration-300 ap:ease-[cubic-bezier(0.87,0,0.13,1)] ap:group-data-[state=open]:rotate-180" />
        </AccordionPrimitive.Trigger>
      </AccordionPrimitive.Header>
      <AccordionPrimitive.Content className="ap:overflow-hidden ap:data-[state=closed]:animate-accordion-up ap:data-[state=open]:animate-accordion-down">
        <div className="ap:px-2xl ap:pb-2xl">{children}</div>
      </AccordionPrimitive.Content>
    </AccordionPrimitive.Item>
  )
}

AccordionPanel.Item = AccordionPanelItem
